import { ChangeDetectionStrategy, Component, Inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { RouterModule } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';


declare var $: any;

@Component({
  templateUrl: './.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, RouterModule, NzIconModule, NzButtonModule, NzWaveModule, NzPopconfirmModule]
})
export class PaylasKartMenuComponent extends FikoYTKokBilesenComponent implements OnDestroy {


  constructor(@Inject(NZ_MODAL_DATA) public data: any,) {
    super();

  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

}
